import { ALL_USERS, SET_USER_PAGE, SET_USER_PAGE_SIZE, SET_USER_TOTAL } from "../types"

const setUserPage = (page) => ({
    type: SET_USER_PAGE,
    payload: page,
})

const setUserPageSize = (size) => ({
    type: SET_USER_PAGE_SIZE,
    payload: size,
})

const setUserTotal = (total) => ({
    type: SET_USER_TOTAL,
    payload: total,
})

const setAllUsers = (data) => {
    return {
        type: ALL_USERS,
        data
    }
}

export {
    setAllUsers,
    setUserPage,
    setUserPageSize,
    setUserTotal
}
